import { ClassicPreset } from "rete";
import { Container } from 'inversify';

export class StoreProcedureControl extends ClassicPreset.Control {
  constructor(public rootComponentId:number,public currentComponentId:number,public applicationId:number, public applicationVersion:number,public variableConnectionInput: string,public variableProcNameInput: string,public variableParametersInput:[],public container: Container | undefined, public onChange: (evt: any) => void,public getNode: (evt: any) => void, public showExpression:(evt:any) => void) {
    super();
  }
}